import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Timeline, TimelineHistory } from '../interfaces/timeline';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimelineService {
  private apiUrl = environment.apiUrl + 'timeline';

  constructor(private http: HttpClient) {}

  getThisMatchingPeriodTimeline(startDate: string, endDate?: string): Observable<Timeline[]> {
    const url = endDate ? `${this.apiUrl}/${startDate}/${endDate}` : `${this.apiUrl}/${startDate}`;
    return this.http.get<Timeline[]>(url).pipe(
      catchError((error) => {
        console.error('Error fetching timeline items:', error);
        return throwError(() => new Error('Failed to fetch timeline items'));
      })
    );
  }

  getHistory(id: string): Observable<TimelineHistory[]> {
    return this.http.get<TimelineHistory[]>(`${this.apiUrl}history/${id}`).pipe(
      catchError((error) => {
        console.error('Error fetching history:', error);
        return throwError(() => new Error('Failed to fetch history'));
      })
    );
  }
}
